<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div style="padding: 0 16px 20px;">
              <div class="addHeader">
                <el-button @click="goback" size="small" type="primary"
                  >返回</el-button
                >
              </div>
              <div class="content">
                <div class="infoTitle">报修内容</div>
                <el-form :model="ruleForm" ref="form" label-width="110px">
                  <el-row :gutter="20" style="margin-bottom: 30px;">
                    <el-col :span="12">
                      <div class="addInfo">
                        <div class="infoExpress">
                          <div class="expLeft">
                            <div class="leftForm">
                              <el-form-item
                                label="报修单流水号"
                                prop="requestSerialNumber"
                              >
                                <el-input
                                  disabled
                                  v-model="ruleForm.requestSerialNumber"
                                  autocomplete="off"
                                ></el-input>
                              </el-form-item>
                              <el-form-item :label="$t('common.carId')" prop="carId">
                                <el-input
                                  disabled
                                  v-model="ruleForm.carId"
                                  autocomplete="off"
                                ></el-input>
                              </el-form-item>
                              <el-form-item label="制造编号" prop="manufactureNum">
                                <el-input
                                  disabled
                                  v-model="ruleForm.manufactureNum"
                                  autocomplete="off"
                                ></el-input>
                              </el-form-item>
                              <el-form-item label="车牌号" prop="plateNum">
                                <el-input
                                  disabled
                                  v-model="ruleForm.plateNum"
                                  autocomplete="off"
                                ></el-input>
                              </el-form-item>
                              <el-form-item
                                prop="remarks"
                                :label="$t('VehicleManagement.situationDescription') + ':'"
                              >
                                <el-input
                                  disabled
                                  size="small"
                                  v-model="ruleForm.description"
                                  autocomplete="off"
                                  type="textarea"
                                  :rows="3"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="addInfo">
                        <div class="infoExpress">
                          <div class="expLeft">
                            <div class="leftForm">
                              <el-form-item label="催单次数" prop="urgeCount">
                                <el-input
                                  disabled
                                  v-model="ruleForm.urgeCount"
                                  autocomplete="off"
                                ></el-input>
                              </el-form-item>
                              <el-form-item label="报修单状态" prop="repairStateStr">
                                <el-input
                                  disabled
                                  v-model="ruleForm.repairStateStr"
                                  autocomplete="off"
                                ></el-input>
                              </el-form-item>
                              <el-form-item label="报修时间" prop="happenTime">
                                <el-input
                                  disabled
                                  v-model="ruleForm.happenTime"
                                  autocomplete="off"
                                ></el-input>
                              </el-form-item>
                              <el-form-item label="报修单关闭时间" prop="closeTime">
                                <el-input
                                  disabled
                                  v-model="ruleForm.closeTime"
                                  autocomplete="off"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" style="margin: 0">
                    <div class="addInfo">
                      <div class="infoExpress" style="padding: 0 0 0 100px">
                        <div class="expLeft">
                          <div class="leftForm" style="margin: 0">
                            <el-form-item
                                prop="ruleForm.filePath"
                                label="维修图片"
                                class="picForm"
                              >
                                <el-upload
                                  disabled
                                  class="avatar-uploader"
                                  :action="processImg"
                                  list-type="picture-card"
                                  :file-list="FileList"
                                  :limit="4"
                                >
                                </el-upload>
                                <!-- <el-dialog v-model="dialogVisible" class="imgForm">
                                  <img
                                    w-full
                                    :src="imageUrl"
                                    alt=""
                                    class="avatar"
                                  />
                                </el-dialog> -->
                              </el-form-item>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-row>
                </el-form>
                <div class="addTab">
                  <div class="tabTitle">
                    <div>维修单</div>
                    <el-button type="text" class="txtTitle" @click="down">导出</el-button>
                  </div>
                  <div class="right-table">
                    <i-table
                      :list="list"
                      :height="height"
                      ref="carTable"
                      :options="option"
                      :columns="columns"
                      :operates="operates"
                    ></i-table>
                    <!-- <i-table
                      ref="table"
                      :column="tableColumn"
                      :options="option"
                      :table-data="tableData"
                      @selection-change="handleSelection"
                      @command="handleAction"
                      class="table-list"
                    >
                    </i-table> -->
                  </div>
                </div>
                <div class="right-dialog">
                  <el-dialog
                    width="1000px"
                    :before-close="closeOperateDia"
                    class="addDialong"
                    :title="$t('Details.repairDetails')"
                    :visible.sync="dialogOperateVisible"
                    :close-on-click-modal="false"
                  >
                    <el-form ref="OperateForm" :model="OperateForm">
                      <el-row :gutter="20" class="dialong-details">
                        <el-col :span="12">
                          <el-form-item
                            prop="serialNumber"
                            :label="$t('Details.repairOrderSerial') + ':'"
                            :label-width="OperateLabelWidth"
                          >
                            <el-input
                              size="small"
                              v-model="OperateForm.serialNumber"
                              autocomplete="off"
                              disabled
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            prop="receiveDuration"
                            :label="$t('Details.responseTime') + ':'"
                            :label-width="OperateLabelWidth"
                          >
                            <el-input
                              size="small"
                              v-model="OperateForm.receiveDuration"
                              autocomplete="off"
                              disabled
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            prop="repairTypeStr"
                            :label="$t('VehicleManagement.repairType') + ':'"
                            :label-width="OperateLabelWidth"
                          >
                            <el-select
                              v-model="OperateForm.repairTypeStr"
                              :placeholder="$t('VehicleManagement.form.repairType')"
                              disabled
                            >
                              <el-option :label="$t('common.all')" value=""></el-option>
                              <el-option
                                :label="$t('VehicleManagement.airStop')"
                                value="1"
                              ></el-option>
                              <el-option
                                :label="$t('VehicleManagement.lowOilCount')"
                                value="2"
                              ></el-option>
                              <el-option
                                :label="$t('VehicleManagement.lowPowerCount')"
                                value="3"
                              ></el-option>
                              <el-option
                                :label="$t('VehicleManagement.lowLiquidLevelCount')"
                                value="4"
                              ></el-option>
                              <el-option
                                :label="$t('VehicleManagement.other')"
                                value="0"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item
                            prop="peopleCost"
                            :label="$t('VehicleManagement.peopleCost') + ':'"
                            :label-width="OperateLabelWidth"
                          >
                            <el-input
                              size="small"
                              v-model="OperateForm.peopleCost"
                              autocomplete="off"
                              disabled
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            prop="operateTime"
                            :label="$t('VehicleManagement.operateTime') + ':'"
                            :label-width="OperateLabelWidth"
                          >
                            <el-date-picker
                              value-format="yyyy-MM-dd"
                              type="date"
                              :placeholder="$t('common.btn.choseDate')"
                              v-model="OperateForm.operateTime"
                              disabled
                            ></el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item
                            prop="receiveTime"
                            :label="$t('Details.orderAcceptanceTime') + ':'"
                            :label-width="OperateLabelWidth"
                          >
                            <el-input
                              size="small"
                              v-model="OperateForm.receiveTime"
                              autocomplete="off"
                              disabled
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            prop="userName"
                            :label="$t('VehicleManagement.maintenancePerson') + ':'"
                            :label-width="OperateLabelWidth"
                          >
                            <el-input
                              size="small"
                              v-model="OperateForm.userName"
                              autocomplete="off"
                              disabled
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            prop="operateDuration"
                            :label="$t('Details.repairDuration') + ':'"
                            :label-width="OperateLabelWidth"
                          >
                            <el-input
                              size="small"
                              v-model="OperateForm.operateDuration"
                              autocomplete="off"
                              disabled
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            prop="materialCost"
                            :label="$t('Details.materialCost') + ':'"
                            :label-width="OperateLabelWidth"
                          >
                            <el-input
                              size="small"
                              v-model="OperateForm.materialCost"
                              autocomplete="off"
                              disabled
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-form-item
                        prop="filePath"
                        :label="$t('common.picture')"
                        :label-width="OperateLabelWidth"
                        style="margin-top: 20px"
                      >
                        <el-upload
                          class="avatarOperate-uploader"
                          list-type="picture-card"
                          :action="processImg"
                          :file-list="FileOperateList"
                          :limit="4"
                          :on-preview="handleOperatePictureCardPreview"
                          disabled
                        >
                        </el-upload>
                        <el-dialog
                          :visible.sync="dialogFileOperateVisible"
                          append-to-body
                          class="imgForm"
                        >
                          <img width="100%" :src="imageOperateUrl" alt="" class="avatar" />
                        </el-dialog>
                      </el-form-item>
                      <div style="margin-top: 10px; font-size: 16px">
                        {{ $t("VehicleManagement.repariContent") }}
                      </div>
                      <detailsTable ref="detailTable"></detailsTable>
                      <p style="text-align: right">
                        {{ $t("VehicleManagement.totalMoneny")
                        }}{{ OperateForm.materialCost }}
                      </p>
                    </el-form>
                  </el-dialog>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="addStyle">
    <div class="addContent">
      <el-scrollbar>
        <div class="addHeader">
          <el-button @click="goback" size="small" type="primary"
            >返回</el-button
          >
        </div>
        <div class="content">
          <div class="infoTitle">报修内容</div>
          <el-form :model="ruleForm" ref="form" label-width="110px">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="addInfo">
                  <div class="infoExpress">
                    <div class="expLeft">
                      <div class="leftForm">
                        <el-form-item
                          label="报修单流水号"
                          prop="requestSerialNumber"
                        >
                          <el-input
                            disabled
                            v-model="ruleForm.requestSerialNumber"
                            autocomplete="off"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="车辆编号" prop="carId">
                          <el-input
                            disabled
                            v-model="ruleForm.carId"
                            autocomplete="off"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="制造编号" prop="manufactureNum">
                          <el-input
                            disabled
                            v-model="ruleForm.manufactureNum"
                            autocomplete="off"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="车牌号" prop="plateNum">
                          <el-input
                            disabled
                            v-model="ruleForm.plateNum"
                            autocomplete="off"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="addInfo">
                  <div class="infoExpress">
                    <div class="expLeft">
                      <div class="leftForm">
                        <el-form-item label="催单次数" prop="urgeCount">
                          <el-input
                            disabled
                            v-model="ruleForm.urgeCount"
                            autocomplete="off"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="报修单状态" prop="repairStateStr">
                          <el-input
                            disabled
                            v-model="ruleForm.repairStateStr"
                            autocomplete="off"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="报修时间" prop="happenTime">
                          <el-input
                            disabled
                            v-model="ruleForm.happenTime"
                            autocomplete="off"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="报修单关闭时间" prop="closeTime">
                          <el-input
                            disabled
                            v-model="ruleForm.closeTime"
                            autocomplete="off"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin: 0">
              <div class="addInfo">
                <div class="infoExpress" style="padding: 0 0 0 100px">
                  <div class="expLeft">
                    <div class="leftForm" style="margin: 0">
                      <el-form-item
                        prop="filePath"
                        label="维修图片"
                        class="picForm"
                      >
                        <el-upload
                          disabled
                          class="avatar-uploaders"
                          :action="processImg"
                          list-type="picture-card"
                          v-model:file-list="fileList"
                          :limit="4"
                          :on-preview="handlePictureCardPreview"
                        >
                        </el-upload>
                        <el-dialog v-model="dialogVisible" class="imgForm">
                          <img
                            w-full
                            :src="imageUrl"
                            alt=""
                            class="avatar"
                          />
                        </el-dialog>
                      </el-form-item>
                    </div>
                  </div>
                </div>
              </div>
            </el-row>
          </el-form>
          <div class="addTab">
            <div class="tabTitle">
              <div>维修单</div>
              <div class="txtTitle" @click="down">导出</div>
            </div>
            <div class="right-table">
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
            </div>
          </div>
          <div class="right-dialog">
           
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div> -->
</template>

<script>
import Details from "./Details";
export default Details;
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/Style.less";
@import url("./Details.less");
</style>
